import { DropdownDivider, DropdownItem } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'

interface AtividadeColetivaGruposTableDropdownMenuProps {
  readonly isGrupoAtivo: boolean
  readonly onExcluir: () => void
  readonly onEditar: () => void
  readonly onUpdateStatusAtivo: () => void
}

export function AtividadeColetivaGruposTableDropdownMenu(props: AtividadeColetivaGruposTableDropdownMenuProps) {
  const { isGrupoAtivo, onExcluir, onEditar, onUpdateStatusAtivo } = props

  return (
    <DropdownButton>
      <DropdownItem onClick={onEditar}>Editar grupo</DropdownItem>
      <DropdownItem onClick={onUpdateStatusAtivo}>{isGrupoAtivo ? 'Inativar grupo' : 'Ativar grupo'}</DropdownItem>
      <DropdownDivider />
      <DropdownItem type='danger' onClick={onExcluir}>
        Excluir grupo
      </DropdownItem>
    </DropdownButton>
  )
}
